import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';
import { lerp } from '../utils/maths';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                closeButton: 'close',
                nextButton: 'next',
                prevButton: 'prev'
            }
        }
    }

    init() {
        
        this.swiperImages = new Swiper(this.$('sliderImages')[0], {
            loop: true,
            centeredSlides: true,
            speed: 1000,
            parallax: true,
            longSwipesRatio: 0.25,
            keyboard: {
                enabled: true
            }
        });

        this.touchStartX = null;
        this.touchOffsetX = null;

        this.swiperImages.on('update', (event) => {

        });

        this.swiperText = new Swiper(this.$('sliderText')[0], {
            loop: true,
            centeredSlides: true,
            speed: 1000,
            effect: 'fade',
            longSwipesRatio: 0.25,
            fadeEffect: {
                crossFade: true
            }
        });

        this.swiperPrev = new Swiper(this.$('sliderPrev')[0], {
            loop: true,
            centeredSlides: true,
            speed: 1000,
            allowTouchMove: false,
            direction: 'vertical',
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            }
        });
        this.swiperNext = new Swiper(this.$('sliderNext')[0], {
            loop: true,
            centeredSlides: true,
            speed: 1000,
            allowTouchMove: false,
            direction: 'vertical',
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            }
        });

        this.length = this.swiperImages.slides.length - this.swiperImages.loopedSlides*2;

        let index = this.swiperImages.realIndex;
        this.swiperPrev.slideToLoop((index > 0) ? parseInt(index-1) : this.length-1);
        this.swiperNext.slideToLoop((index < this.length - 1) ? parseInt(index+1) : 0);

        this.swiperText.controller.control = this.swiperImages;
        this.swiperImages.controller.control = this.swiperText;

        this.swiperImages.on('slideChange',() => {
            let index = this.swiperImages.realIndex;
            // console.log((index > 0) ? parseInt(index-1) : this.length-1);
            this.swiperPrev.slideToLoop((index > 0) ? parseInt(index-1) : this.length-1);
            this.swiperNext.slideToLoop((index < this.length - 1) ? parseInt(index+1) : 0);
        });

    }

    close() {
        this.call('click','MembersButton');
    }

    goto(index) {
        this.swiperImages.slideToLoop(parseInt(index),0);
        let previousIndex = (index > 0) ? parseInt(index-1) : this.length-1;
        let nextIndex = (index < this.length - 1) ? parseInt(index+1) : 0;
        
        this.swiperPrev.slideToLoop(previousIndex,0);
        this.swiperNext.slideToLoop(nextIndex,0);
    }

    prev() {
        this.swiperImages.slidePrev();
    }

    next() {
        this.swiperImages.slideNext();
    }

    destroy() {
        cancelAnimationFrame(this.raf);
    }
}